import { render, staticRenderFns } from "./OppositeBookingsPopup.vue?vue&type=template&id=6184a03a&"
import script from "./OppositeBookingsPopup.vue?vue&type=script&lang=js&"
export * from "./OppositeBookingsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports